export default function (context, val) {
  let settings = context.rootState.user.setting.items;
  context.commit('set_load', {
    data: false,
  });
  context.dispatch('set_title', 'Добавление платежей', {root: true});
  let date = new Date();
  let category = context.rootGetters['dictionary/paymentType/getById'](settings.DefaultPaymentType).CategoryId;
  let cash = settings.DefaultPaymentSource;
  let account = settings.DefaultPaymentSource;
  switch (category) {
    case 0:
      if (!context.rootState.dictionary.cash.list.filter(i => i.value === cash)[0]) {
        if (context.rootState.dictionary.cash.list[0]) cash = context.rootState.dictionary.cash.list[0].value;
      }
      break;
    case 1:
      if (!context.rootState.dictionary.paymentAccount.list.filter(i => i.value === account)[0]) {
        if (context.rootState.dictionary.paymentAccount.list[0]) account = context.rootState.dictionary.paymentAccount.list[0].value;
      }
      break;
  }
  context.commit('set_form', {
    Id: 0,
    Name: '',
    NameLat: '',
    CertificateId: '',
    CertificateName: '',
    PaymentDirection: settings.DefaultPaymentDirection,
    PaymentOperationID: settings.DefaultPaymentOperation,
    RateArticleId: null,
    CategoryId: context.rootGetters['dictionary/paymentType/getById'](settings.DefaultPaymentType).CategoryId,
    PaymentTypeId: settings.DefaultPaymentType,
    CashId: cash,
    PaymentAccountId: account,
    AccountNumber: '',
    ContragentType: context.rootGetters['dictionary/contragentType/list'](settings.DefaultPaymentOperation)[0].value,
    ContragentID: null,
    ContragentName: '',
    PartnerLegalEntityId: null,
    Sum: 0,
    BankCommission: 0,
    CurrencyId: 1,
    PaymentDate: '' + (date.getDate() > 9 ? '' : '0') + date.getDate() + '.' + (date.getMonth() > 8 ? '' : '0') + (date.getMonth() + 1) + '.' + date.getFullYear(),
    DocumentNumber: settings.DefaultPaymentDirection === 0 ? context.state.system.IncomePaymentNumber : context.state.system.OutcomePaymentNumber,
    Comment: '',
    RegularPaymentTypeId: 0,
    dayMonth: 1,
    dayWeek: 1,
    dayYear: '',
    dayOne: '',
    NotificationsEndDate: '',
    AgreementCodes: [],
  });
  if (settings.DefaultPaymentOperation === 0) {
    context.dispatch('change_PaymentDirection', settings.DefaultPaymentDirection);
  }
}